import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/apiClient";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ menu: 0, events: 0, popups: 0, contacts: 0 });

    const fetchStats = useCallback(async () => {
        try {
            const [menu, events, popups, contacts] = await Promise.all([
                api.get("/admin/menu"),
                api.get("/admin/events"),
                api.get("/admin/popups"),
                api.get("/admin/contacts"),
            ]);
            setStats({
                menu: menu.data.length,
                events: events.data.length,
                popups: popups.data.length,
                contacts: contacts.data.length,
            });
        } catch (_e) {
            // ignore
        }
    }, []);

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    const cards = [
        { label: "Articles à la carte", value: stats.menu },
        { label: "Évènements", value: stats.events },
        { label: "Pop-ups", value: stats.popups },
        { label: "Messages reçus", value: stats.contacts },
    ];

    return (
        <div data-testid="admin-dashboard">
            <p className="section-tag">vue d’ensemble</p>
            <h1 className="font-serif-display text-4xl text-[#2A1408] tracking-tight">
                Tableau de bord
            </h1>
            <p className="mt-2 text-[#5C3D2E]">
                Bienvenue dans l’espace administration du Comptoir du Cookie.
            </p>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
                {cards.map((c) => (
                    <div key={c.label} className="brand-card p-6">
                        <p className="text-xs uppercase tracking-widest text-[#B07B66]">
                            {c.label}
                        </p>
                        <p className="font-serif-display text-4xl text-[#2A1408] mt-2">
                            {c.value}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
